<template>
  <div class="item">
    <div class="box">
      <img
        :src="'http://www.xinhuoa.com:2363/upload/' + listitem.more.thumbnail"
        alt=""
        style="width: 80%"
      />
    </div>

    <div class="title">{{ listitem.post_title }}</div>
    <div class="more">了解更多</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    listitem: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {}
  },
  created() {},
  mounted() {
    console.log(listitem)
  },
  methods: {},
}
</script>
 
<style lang="less" scoped>
.item {
  cursor: pointer;
  box-sizing: content-box;
  width: 7rem;
  height: 8.92rem;
  margin-bottom: 0.98rem;
  margin-right: 0.9rem;
  .box {
    width: 7rem;
    height: 7.1rem;
    background: #f4f4f4;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title {
    width: 100%;
    text-align: center;
    height: 0.39rem;
    font-size: 0.4rem;
    font-family: OPPOSans;
    font-weight: bold;
    // margin: 0 auto;
    margin: 0.35rem 0px;

    color: #333333;
  }
  .more {
    width: 1.8rem;
    height: 0.74rem;
    line-height: 0.74rem;
    text-align: center;
    border: 0.01rem solid #009269;
    margin: 0 auto;

    font-size: 0.32rem;
    font-family: OPPOSans;
    font-weight: 500;
    color: #009742;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Item.vue